// extracted by mini-css-extract-plugin
module.exports = {"mark":"bs_jb","mark_color_default":"bs_jc","mark_color_green":"bs_jd","mark_fill":"bs_jf","mark_color_red":"bs_jg","mark_color_blue":"bs_jh","mark_bold":"bs_jj"};